import React from 'react';
import Chart from "react-apexcharts";

const BarGraph = ({data}) => {
    if (!data) return (null)

        const state = {
            options: {
                width: '100%',
                height: "auto",
                grid: {
                    yaxis: {
                        lines: {
                            show: false
                        }
                    },
                    xaxis: {
                        lines: {
                            show: false
                        }
                    },
                },
                chart: {
                    // height: 200,
                    type: 'bar',
                },
                plotOptions: {
                    bar: {
                        borderRadius: 10,
                    },
                },
                colors: ['#76B02C'],
                dataLabels: {
                    enabled: false,
                },
                xaxis: {
                    categories: data?.map(item => item?.name) || [],
                    labels: {
                        show: false,
                    },
                    tooltip: {
                        enabled: true,
                    }
                },
                yaxis: {
                    labels: {
                        show: false,
                    },
                }
            },
            series: [
                {
                    name: `Sales`,
                    data: data?.map(item => item.amount) || [],
                    labels: {
                        show: false,
                    },
                }
            ],
        };


        return (
            <Chart
                options={state.options}
                series={state.series}
                type="bar"
            />
        )
};

export default BarGraph;
